import {
  optionalLiteralParam,
  optionalStringParam,
  parseableSearchSchema,
} from "@crm/effect/schema/search";
import { Schema } from "effect";

/**
 * Students 路由 URL search params schema
 *
 * 规范模式：
 * - 有默认值的字段：fallback(schema, val).default(val)
 *   → 畸形 URL 优雅降级 + 缺失时填充默认值 + Link 导航时可省略
 * - 可选筛选字段：schema.optional()
 *   → 缺失为 undefined，Link 导航时可省略
 */
export const studentsSearchSchema = parseableSearchSchema(
  Schema.Struct({
    // 可选：缺省 = 人列表，不按报名课程收口
    courseCode: optionalLiteralParam("wp", "sio"),

    // 可选筛选：plain .optional()（缺失时 undefined）
    classSessionId: optionalStringParam(),
    siteStatus: optionalLiteralParam(
      "not_started",
      "building",
      "stalled",
      "online",
      "need_improve",
    ),
    inquiryStatus: optionalLiteralParam("has_inquiry", "no_inquiry"),
    topicStatus: optionalLiteralParam("has_topic", "no_topic"),
    stage: optionalLiteralParam("lead", "prospect", "customer", "enrolled", "graduated", "churned"),
  }),
);

export type StudentsSearch = Schema.Schema.Type<typeof studentsSearchSchema>;
